import { useMutation, useQueryClient } from '@tanstack/react-query';
import { editAppGeneral } from 'api/appManager';
import { LIST_APP_QUERY } from 'constants/QueryString';

const useEditGeneral = () => {
  const queryClient = useQueryClient();

  const {
    data,
    error,
    isError,
    isIdle,
    isPending,
    isPaused,
    isSuccess,
    failureCount,
    failureReason,
    mutate,
    mutateAsync,
    reset,
    status,
    submittedAt,
    variables,
    isLoading,
  } = useMutation({
    mutationFn: editAppGeneral,
    onSuccess: () => {
      queryClient.removeQueries({ queryKey: [LIST_APP_QUERY] });
    },
    onError: (error) => {
      console.error('Error editing app general information:', error);
      // Handle the error, show error message, etc.
    },
  });
  return {
    data,
    error,
    isError,
    isIdle,
    isPending,
    isPaused,
    isSuccess,
    failureCount,
    failureReason,
    mutate,
    mutateAsync,
    reset,
    status,
    submittedAt,
    variables,
    isLoading,
  };
};

export default useEditGeneral;
